module.exports = __webpack_public_path__ + "img/quick_scan.fa5a812f.png";